import { uniqBy, filter } from 'lodash'

import { parseUrl } from '../helpers/helpers'

export const SHOP_SET_PRODUCTS = 'SHOP_SET_PRODUCTS'

const initialState = {
  products: [],
  categories: [],
  gifts: [],
}

const getCategory = (product) => {
  return {
    categoryUrl: parseUrl(product.category),
    categoryName: product.category,
  }
}
const shopReducer = (state = initialState, action) => {
  switch (action.type) {
    case SHOP_SET_PRODUCTS:
      const uniqueCategories = uniqBy(action.products, (p) => p.category).map(getCategory)
      const gifts = filter(action.products, { name: 'Gift' })[0]
      const giftSku = gifts ? (gifts.sku ? gifts.sku.slice() : []) : []
      return {
        ...state,
        products: [
          ...action.products.map((p) => ({
            ...p,
            productUrl: parseUrl(p.name),
            categoryUrl: parseUrl(p.category),
          })),
        ],
        categories: [...uniqueCategories],
        gifts: giftSku,
      }
    default:
      return state
  }
}

export const setShopProducts = (products) => {
  return {
    type: SHOP_SET_PRODUCTS,
    products,
  }
}

export default shopReducer
